<script setup>
// Changing Background
import { useBg } from '@/stores/bgStore';
import { useIntersectionObserver } from '@vueuse/core';
import { ref } from 'vue';
import ButtonLink from '../Buttons/ButtonLink.vue';
import ImgMedia from '../Images/ImgMedia.vue';

const bg = useBg();
const target = ref(null);

useIntersectionObserver(target, ([{ isIntersecting }], observerElement) => {
    isIntersecting ? bg.add('about') : bg.remove('about');
});

const props = defineProps({
    title: String,
    text: String,
    image: Object,
    button_label: String,
    external_url: String,
    intended_url: String,
    url: String,
    flip_order: Boolean,
    small_title: Boolean,
});
</script>

<template>
    <div ref="target" class="container my-16 md:my-30">
        <div class="grid items-center gap-12 xl:grid-cols-2">
            <div class="xl:order-2" :class="{ 'xl:order-1': flip_order }" v-if="image">
                <ImgMedia :media="image" classes="" />
                <div class="h-2 mx-4 bg-secondary"></div>
            </div>

            <div class="xl:order-1" :class="{ 'xl:order-2': flip_order }">
                <h2 class="mb-4 text-2xl font-bold" :class="{ 'xl:text-[64px] md:mb-12': !small_title }" v-if="title">
                    {{ title }}
                </h2>
                <div v-html="text" class="mb-6 prose text-primary"></div>

                <ButtonLink :href="intended_url" :label="button_label" :external="url == null" />
            </div>
        </div>
    </div>
</template>
